export default {
  set (state, cashReturns) {
    state.cashReturns = cashReturns
  }
}
